export const HYPERTENSION = { id: 'hypertension', label: 'Ipertensione' };
export const DIABETES = { id: 'diabetes', label: 'Diabete' };
export const OTHER_CHRONIC_SYSTEMIC_PATHOLOGY = {
  id: 'other_chronic_systemic_pathology',
  label:
    'Altra patologia cronica sistemica (ematologica, autoimmune, endocrinopatia, cardiopatia, renale, ginecologica, neurologica, respiratoria, digerente, infezione)',
};
export const MENTAL_DISORDERS = {
  id: 'mental_disorders',
  label: 'Disturbi psichici (psicotici, dell’umore, d’ansia, da condizione medica generale)',
};
export const ADDICTIONS = { id: 'addictions', label: 'Dipendenze' };
export const TUMOR_PATHOLOGY = { id: 'tumor_pathology', label: 'Patologia tumorale' };
export const OTHER = { id: 'other', label: 'Altro (interventi chirurgici pregressi, altro)' };
